export const toggleSidebar = () => ({ type: 'TOGGLE_SIDEBAR' })


// WEBPACK FOOTER //
// ./src/actions/uiActions.js